import datesArrayBuilder from "../filterTranforms/datesArrayBuilder";
import classNames from "classnames";

export interface MiniCalendarTableProps {
  weekSelected: Date;
  today: Date;
  month: number;
  year: number;
  onSelectDay: (day: Date) => void;
}

const MiniCalendarTable = (props: MiniCalendarTableProps) => {
  const { weekSelected, today, month, year } = props;
  const { onSelectDay } = props;
  const weeksArray = datesArrayBuilder(month, year, weekSelected, today);
  const targetWeekRows = 6;
  const emptyWeeksCount = Math.max(targetWeekRows - weeksArray.length, 0);
  const dayCellBaseClassName = "w-6 h-6 leading-6 text-center align-middle";

  return (
    <table
      id="minicalendartable"
      className="bg-white border-separate border-spacing-x-3 border-spacing-y-1"
    >
      <tbody>
        <tr>
          {["D", "L", "M", "M", "J", "V", "S"].map((day, idx) => (
            <td className="font-bold text-center" key={day + idx}>
              {day}
            </td>
          ))}
        </tr>
        {weeksArray.map((week) => (
          <tr
            key={
              week[0].year.toString() +
              week[0].month.toString() +
              week[0].day.toString()
            }
          >
            {week.map((obj) => (
              <td
                className={classNames(
                  dayCellBaseClassName,
                  "cursor-pointer hover:bg-gray-300 rounded-md",
                  {
                    ["bg-gray-300"]: obj.type === "other_month_day",
                    ["bg-gray-300 rounded-md"]: obj.type === "displayed_week",
                    ["bg-blue-200 rounded-md font-bold"]:
                      obj.type === "today_day",
                  },
                )}
                onClick={onSelectDay.bind(
                  null,
                  new Date(obj.year, obj.month, obj.day),
                )}
                key={
                  obj.year.toString() +
                  obj.month.toString() +
                  obj.day.toString()
                }
              >
                {obj.day}
              </td>
            ))}
          </tr>
        ))}
        {Array.from({ length: emptyWeeksCount }, (_, weekIndex) => (
          <tr key={`empty-week-${weekIndex}`}>
            {Array.from({ length: 7 }, (_, dayIndex) => (
              <td
                key={`empty-day-${weekIndex}-${dayIndex}`}
                className={dayCellBaseClassName}
              >
                <span className="invisible">0</span>
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default MiniCalendarTable;
